export const toISODateString = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const isBeforeToday = (date: Date): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const compared = new Date(date);
    compared.setHours(0, 0, 0, 0);

    return compared < today;
};

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const countDayIndex = (date: Date): number => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const target = new Date(date);
    target.setHours(0, 0, 0, 0);

    return Math.round((target.getTime() - today.getTime()) / MS_PER_DAY);
};
